/**
 * 设置 cookie
 * 不支持设置 domain
 */
export const setCookie = ({
  name,
  value,
  expires = undefined,
  path = '/',
}: {
  name: string;
  value: string;
  expires?: string;
  path?: string;
}) => {
  let expiresNew;
  if (!expires) {
    const Days = 30;
    const exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    expiresNew = exp.toUTCString();
  } else {
    expiresNew = expires;
  }
  document.cookie = `${name}=${value};expires=${expiresNew};path=${path}`;
};

export function getCookie(key: string) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`),
        '$1',
      ),
    ) || null
  );
}

export function removeCookie(key: string) {
  document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
}
